// Drafts carry no invoice number (2026-10-07): a number is given when the
// invoice is issued, so the run follows the order invoices go out. Until then
// the server stores a unique placeholder, "DRAFT-<id>", shown as "Draft <id>".

const DRAFT_PREFIX = "DRAFT-";

export const isDraftNumber = (number) =>
  String(number || "").startsWith(DRAFT_PREFIX);

export function displayInvoiceNumber(number) {
  if (!number) return "";
  return isDraftNumber(number)
    ? `Draft ${String(number).slice(DRAFT_PREFIX.length)}`
    : String(number);
}

// Chrome's Save-as-PDF names the file after the document title. The firm files
// invoices by client, so the client leads: "Acme Ltd - 27-037 - 2026-10-20".
// Characters Windows will not take in a filename become dashes.
export function invoicePdfTitle({ clientName, number, date } = {}) {
  const parts = [clientName, displayInvoiceNumber(number), date]
    .map((part) => String(part || "").replace(/[\\/:*?"<>|]/g, "-").trim())
    .filter(Boolean);
  return parts.length ? parts.join(" - ") : "Invoice";
}
